import { useMemo } from 'react';

import { InputGroupV2, UniversalSelect } from '@equip.health/ui';

import {
  buildUniversalSelectSearchTerm,
  getSelectedUniversalSelectOption,
} from '~/lib/util/inquiry.util';

import { DropdownBaseProps } from './types';
import { useGetProviderTimezonesEnumQuery } from '~/store/services/enumerations';

const TimezoneDropdown = ({ id, onSelect, value }: DropdownBaseProps) => {
  const { data: timezoneEnums } = useGetProviderTimezonesEnumQuery();

  const timezoneOptions = useMemo<UniversalSelectOption[]>(() => {
    return (timezoneEnums || []).map(({ label }) => ({
      label,
      searchData: buildUniversalSelectSearchTerm(label),
      value: label,
    }));
  }, [timezoneEnums]);

  return (
    <InputGroupV2 id={`${id}__timezone`} isRequired={false} label="Timezone">
      <UniversalSelect
        id={`${id}__timezone`}
        isSearchable
        isSingleSelect
        onChange={(selected: UniversalSelectOption) =>
          onSelect(selected?.value)
        }
        options={timezoneOptions}
        value={getSelectedUniversalSelectOption(value, timezoneOptions)}
      />
    </InputGroupV2>
  );
};

export default TimezoneDropdown;
